import { FC, useCallback } from 'react';
import { DeviceShadowFeature } from 'models';
import EditDesiredItem from 'components/UI/EditDesired/EditDesiredItem';
import EditDesired from 'components/UI/EditDesired';
import { FieldErrors, FieldValues } from 'react-hook-form';

type Props = {
  id: string;
  family: DeviceShadowFeature;
  register: any;
  errors: FieldErrors<FieldValues>;
  onDesiredRemoved?: (id: string, resourceId: string) => void;
};

const DesiredFamily: FC<Props> = ({
  id,
  family,
  register,
  errors,
  onDesiredRemoved,
}) => {
  const getProperties = useCallback(
    (myFamily: DeviceShadowFeature[], parentKey?: string) => {
      if (!myFamily || !myFamily[0]) {
        return null;
      }
      return myFamily?.map(
        ({ title, children, value, writable, type, range, desired }) => {
          const itemKey = parentKey ? `${parentKey}/${title}` : title;
          if (children) {
            return (
              <div key={itemKey ?? title}>
                <EditDesiredItem
                  id={id}
                  key={itemKey ?? title}
                  itemKey={itemKey}
                  title={title}
                  type={type}
                  range={range}
                  writable={writable}
                  register={register}
                  desired={desired}
                  errors={errors}
                  onDesiredRemoved={onDesiredRemoved}
                >
                  {getProperties(children, itemKey)}
                </EditDesiredItem>
              </div>
            );
          }
          return (
            <EditDesiredItem
              id={id}
              register={register}
              key={itemKey ?? title}
              itemKey={itemKey}
              title={title}
              type={type}
              range={range}
              writable={writable}
              desired={desired}
              errors={errors}
              value={JSON.stringify(value)}
              onDesiredRemoved={onDesiredRemoved}
            />
          );
        }
      );
    },
    [id, register, errors, onDesiredRemoved]
  );

  return (
    <div className="familyView">
      <EditDesired>{getProperties([family])}</EditDesired>
    </div>
  );
};

export default DesiredFamily;
